import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MainLayout from 'layout/MainLayout';

const Error404 = Loadable(lazy(() => import('views/404')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '*',
      element: <Error404 />
    }
  ]
};

export default AuthenticationRoutes;
